import BaseEnum from "./base_enum.js.jsx";

class InvestmentStatusDescriptionEnumDesc extends BaseEnum {

  name() {
    return "investment_status_description";
  }

  rawValues() {
    return ["applied", "paid", "paid_back"];
  }

}

const InvestmentStatusDescriptionEnum = new InvestmentStatusDescriptionEnumDesc();
export default InvestmentStatusDescriptionEnum;